import { cn } from "@/components/podkit/lib/cn";
import type React from "react";

type Props = {
    children: React.ReactNode;
    className?: string;
};
export function KeyboardKey({ children, className }: Props) {
    return (
        <kbd
            className={cn(
                // Using box-shadow for the border as it is more versatile when rendered on different backgrounds, e.g.
                // if a background changes on hover.
                "rounded bg-surface-pure shadow-[0_0_0_1px_rgba(0,0,0,0.08)]",
                "h-5 px-1.5 my-0.5 text-center font-sans text-[12px] capitalize leading-5",
                className,
            )}
        >
            {children}
        </kbd>
    );
}
